import { formatList } from '../../../app/Libraries/Utils';
import { stardust } from '@eidellev/adonis-stardust/client';

import $ from 'jquery';
import littledata from '@littledata/headless-shopify-sdk';
import aa from './algolia-insights';

import {
  formatAsMoney,
  extractID,
  getPageLang,
} from './utils';

import updateVariantImage from './product/update-variant-image';
import ShopifyWrapper, { type CustomAttribute } from '@him-her/shopify-wrapper';

import i18next, { type TFunction } from 'i18next';
import i18nextInstance from './i18next';
let t: TFunction;

const domain = process.env.SHOPIFY_DOMAIN || '';
const storefrontAccessToken = process.env.SHOPIFY_STOREFRONT_TOKEN || '';
let client: ShopifyWrapper;
let cart;

// TODO: Move these to env var?
const PRODUCTS_INDEX = 'shopify_products';
const DEFAULT_INDEX = PRODUCTS_INDEX;

document.addEventListener('DOMContentLoaded', async () => {
  // Testing new wrapper
  // const wrapper = new ShopifyWrapper({
  //   domain,
  //   token: storefrontAccessToken,
  //   metafields: {
  //     product: [{
  //       name: 'publicSku',
  //       namespace: 'custom',
  //       key: 'public_sku',
  //     }],
  //     variant: [{
  //       name: 'publicSku',
  //       namespace: 'custom',
  //       key: 'public_sku',
  //     }],
  //   },
  //  debug: true,
  // });
  // await wrapper.test.cart();
  // debugger;

  try {
    // Load i18next
    t = await i18nextInstance;
    await i18next.loadNamespaces(['general']);

    client = new ShopifyWrapper({
      domain,
      token: storefrontAccessToken,
      apiVersion: '2025-01',
      country: 'CA',
      language: getPageLang().toUpperCase(),
      metafields: {
        product: [{
          name: 'publicSku',
          namespace: 'custom',
          key: 'public_sku',
        }],
        variant: [{
          name: 'publicSku',
          namespace: 'custom',
          key: 'public_sku',
        }],
      },
    });

    // Check if a cart already exists in local storage
    const cartId = localStorage.getItem('lastCartId');
    // Try and fetch the cart if we have an ID
    if (cartId) {
      cart = await client.cart.fetch(cartId);
    }

    if (!cart) {
      // If cart wasn't found, or we didn't have an ID, create a new cart
      cart = await client.cart.create();
    }

    // render the new cart
    localStorage.setItem('lastCartId', cart.id);

    updateCartTabButton();

    // Add littledata client IDs to Shopify cart
    if (Cookiebot?.consent.statistics) {
      // https://www.npmjs.com/package/@littledata/headless-shopify-sdk?activeTab=readme#using-the-shopify-cart-api
      await littledata
        .fetchClientIds({
          // cSpell:disable-next-line
          ga4MeasurementId: 'G-0QLGEFWDB3',
          fbPixelId: '306601538442852',
        });
      // console.debug('littledata ids', clientIds);

      // Send cart info to littledata
      const noteAttributes = await littledata.sendCartToLittledata(cart.id);
      console.debug('littledata noteAttributes', noteAttributes);

      client.cart.updateAttributes(cart.id, noteAttributes);
    }

    // bind everything
    bindEventListeners();

    // set valid selectors on single product pages
    initVariantSelectors();
  } catch (err) {
    console.error(err);
  }
});

function initVariantSelectors() {
  if (!document.querySelector('main.product')) {
    return;
  }

  if (!document.querySelector('.js-variant-selector')) {
    return;
  }

  const selectedVariants = document.querySelectorAll<HTMLInputElement>('.js-variant-selector input:checked');

  selectedVariants.forEach((selectedVariant) => {
    const name = selectedVariant.dataset.option as string;
    const value = selectedVariant.value;
    const handle = selectedVariant.dataset.product as string;

    client.product.fetchByHandle(handle).then((product) => {
      showAvailableVariants(name, value, product);
    });
  });
}

/**
 * Bind Event Listeners
 */
function bindEventListeners() {
  /* buy button click listener for single product pages */

  let addToCartBtns = document.querySelectorAll<HTMLElement>('.product .js-add-to-cart');

  addToCartBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      btn.setAttribute('disabled', 'true');
      btn.classList.add('processing');

      const variantID = btn.dataset.id as string;

      let customAttributes: CustomAttribute[] = [];

      let ringSizeSelectors = document.querySelector('.single-product__ring-size-selectors');

      if (ringSizeSelectors) {
        const ringSize = ringSizeSelectors.querySelector<HTMLInputElement>('input:checked')?.dataset.ringsize;

        customAttributes.push({
          key: 'Size',
          value: ringSize || '',
        });
      }

      buyButtonClickHandler(variantID, customAttributes);
    });
  });

  const quickBuyBtns = document.querySelectorAll<HTMLElement>('.js-buy-now');

  quickBuyBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      btn.setAttribute('disabled', 'true');
      btn.classList.add('processing');

      const variantID = btn.dataset.id as string;

      let customAttributes: CustomAttribute[] = [];

      const ringSizeSelectors = document.querySelector('.single-product__ring-size-selectors');

      if (ringSizeSelectors) {
        const ringSize = ringSizeSelectors.querySelector<HTMLInputElement>('input:checked')?.dataset.ringsize || '';

        customAttributes.push({
          key: 'ringSize',
          value: ringSize,
        });
      }

      buyButtonClickHandler(variantID, customAttributes, true);
    });
  });

  // collection add to carts
  // TODO: figure out how to export the function so that its not run multiple times on instantsearch.js file

  $('.collection, .search-results__product-grid, .product-list, .featured-product')
    .on('click', '.js-add-to-cart', (e) => {
      const btn = e.currentTarget;

      const variantID = btn?.dataset.id;

      // btn.setAttribute('disabled', 'true');
      btn.classList.add('processing');

      buyButtonClickHandler(variantID, []);
    });

  let variantSelectors = document.querySelectorAll('.js-variant-selector');

  variantSelectors.forEach((selector) => {
    let input = selector.querySelector<HTMLInputElement>('input');
    if (!input) {
      return;
    }

    input.addEventListener('change', () => {
      const name = input!.dataset.option as string;
      const value = input!.value;
      const quantity = 1;
      const handle = input!.dataset.product as string;

      const allInputs = document.querySelectorAll<HTMLInputElement>(`.js-variant-selector input[data-product="${handle}"]:checked`);

      const selectedOptions = [...allInputs].map((input) => {
        return {
          name: input.dataset.option as string,
          value: input.value,
        };
      });

      // update label if it exists
      const label = document.querySelector(`.js-selected-option[data-option="${name}"]`);

      if (label) {
        label.innerHTML = `${name}: ${value}`;
      }

      client.product.fetchByHandle(handle).then((product) => {
        setSelectedVariant(name, value, product, quantity, selectedOptions);
      });
    });
  });
}

/**
 * Update cart tab button
 */
function updateCartTabButton() {
  client.cart
    .fetch(cart.id)
    .then((cart) => {
      const cartLinks = document.querySelectorAll('.js-nav-cart');
      if (cart.lineItems.length > 0) {
        cartLinks.forEach((link) => {
          link.classList.add('has-items');
        });
      } else {
        cartLinks.forEach((link) => {
          link.classList.remove('has-items');
        });
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

/**
 * Attach and control listeners onto buy button
 */
function buyButtonClickHandler(
  variantID: string,
  customAttributes: CustomAttribute[] = [],
  quickBuy: boolean = false
) {
  const quantity = 1;

  const lineItemsToAdd = [
    {
      variantId: variantID,
      quantity,
      customAttributes: customAttributes,
    },
  ];

  const btns = document.querySelectorAll<HTMLElement>(`.js-add-to-cart[data-id="${variantID}"]`);
  const productCard = btns[0]?.closest('.js-product');

  // Add an item to the cart
  client.cart
    .addLineItems(cart.id, lineItemsToAdd)
    .then((newCart) => {
      cart = newCart;
      return newCart;
    })
    .then(() => {
      updateCartTabButton();

      const SUCCESS_TIMEOUT_MS = 4000;

      btns.forEach((btn) => {
        btn.removeAttribute('disabled');
        btn.classList.remove('processing');
        btn.classList.add('success');

        // If it's the product page, show success state
        if (btn.classList.contains('single-product__bag-btn')) {
          btn.innerText = t('general:product.addedToBag');
        } else {
          // If not on product page, remove success class after timeout
          setTimeout(() => {
            btn.classList.remove('success');
          }, SUCCESS_TIMEOUT_MS);
        }
      });

      let variant;

      cart.lineItems.forEach((product) => {
        // check that the product still exists in Shopify
        if (product.variant.id === variantID) {
          variant = product;
        }
      });

      buyButtonAnalytics(variant, cart, productCard);

      // If quick buy, redirect to checkout
      if (quickBuy) {
        window.open(cart.webUrl, '_self');
      }

      return true;
    })
    .catch((err) => {
      console.error(err);
      btns.forEach((btn) => {
        btn.removeAttribute('disabled');
        btn.classList.remove('processing');
      });
    });
}

/**
 * Variant option change handler.
 * Set selected variant based on selected options.
 * @param name The name of the selected option (e.g. "Material")
 * @param value The value of the selected option (e.g. "Rose Gold")
 * @param product The product object
 * @param quantity The quantity of the selected variant
 * @param selectedOptions The selected options
 */
function setSelectedVariant(
  name: string,
  value: string,
  product: any,
  quantity: number,
  selectedOptions: { name: string; value: string; }[],
) {
  let variants = product.variants;

  let selectedVariant;
  let variantInvalid = false;

  // check if valid options
  // product.variants => variant.selectedOptions

  variants.forEach((variant) => {
    let valid = true;
    for (const option of variant.selectedOptions) {
      const selectedOption = selectedOptions.find(
        (selected) => selected.name === option.name
      );
      if (!selectedOption || selectedOption.value !== option.value) {
        valid = false;
        break;
      }
    }
    if (valid) {
      // Selected options are valid for this variant
      selectedVariant = variant;
    }
  });

  // if not valid, exclude the one we just clicked on (name) and find next valid option
  if (!selectedVariant) {
    variantInvalid = true;
    selectedVariant = variants.find((variant) => {
      return variant.selectedOptions.find(
        (option) => option.name === name && option.value === value
      );
    });
  }

  product.selectedVariant = selectedVariant;

  // since selected variant didn't match we need to update checked selectors to match new variant
  if (variantInvalid) {
    updateCheckedSelectors(product);
  }

  updateAddToCartBtn(product);

  const selectedVariants = document.querySelectorAll<HTMLInputElement>(
    '.js-variant-selector input:checked',
  );

  selectedVariants.forEach((selectedVariant) => {
    const name = selectedVariant.dataset.option as string;
    const value = selectedVariant.value;
    const handle = selectedVariant.dataset.product as string;

    client.product.fetchByHandle(handle).then((product) => {
      showAvailableVariants(name, value, product);
    });
  });

  // TODO: we need to update the stock level notices;
  // the existing code from Reids won't work here and we need to grab locations somehow.

  updateProductPageStockStatus(product);

  updateVariantPrice(product, product.selectedVariant, quantity);

  updateVariantSku(product, product.selectedVariant);

  updateURLParams({ v: extractID(product.selectedVariant.id) });

  updateVariantImage(product.selectedVariant.id);
}

/**
 * Updates selectors so they match currently selected variant
 */
function updateCheckedSelectors(product: any) {
  product.selectedVariant.selectedOptions.forEach((option) => {
    const input = document.querySelector<HTMLInputElement>(
      `.js-variant-selector input[data-product="${product.handle}"][data-option="${option.name}"][value="${option.value}"]`,
    );
    if (input) {
      input.classList.remove('disabled');
      input.checked = true;
    }
  });
}

/**
 * Updates add to cart button with selected variant ID
 */
function updateAddToCartBtn(product) {
  const addToCartBtn = document.querySelector(
    `.js-product[data-product="${product.handle}"] .js-add-to-cart`,
  );

  const quickBuyBtn = document.querySelector(
    `.js-product[data-product="${product.handle}"] .js-quick-buy`,
  );

  addToCartBtn?.setAttribute('data-id', product.selectedVariant.id);
  quickBuyBtn?.setAttribute('data-id', product.selectedVariant.id);
}

/**
 * Disable any variant options that aren't available for a product
 */
function showAvailableVariants(name: string, value: string, product: any) {
  if (product.options && product.options.length > 1) {
    // grab all variant selector inputs for current product that aren't the ones we just changed

    const allOtherInputs = document.querySelectorAll<HTMLInputElement>(
      `.js-variant-selector input[data-product="${product.handle}"]:not([data-option="${name}"])`,
    );

    let validOptions: {
      name: string;
      value: string;
    }[] = [];

    product.variants.forEach((variant) => {
      if (
        variant.selectedOptions.some(
          (option) => option.name === name && option.value === value
        )
      ) {
        variant.selectedOptions.forEach((option) => {
          // make sure its not the option we just clicked and that its in stock
          if (option.name !== name) {
            validOptions.push({
              name: option.name,
              value: option.value,
            });
          }
        });
      }
    });

    // visually disable any inputs that aren't valid
    allOtherInputs.forEach((input) => {
      if (
        !validOptions.some(
          (option) => (option.name === input.dataset.option) && (option.value === input.value)
        )
      ) {
        input.classList.add('disabled');
      } else {
        input.classList.remove('disabled');
      }
    });
  }
}

/**
 * Update product price based on variant
 */
function updateVariantPrice(product: any, variant: any, quantity = 1) {
  // console.debug('updateVariantPrice', product, variant, quantity);
  if (!variant) {
    return;
  }

  const priceEls = document.querySelectorAll<HTMLElement>(
    `.js-product[data-product="${product.handle}"] .js-product-price`,
  );

  let priceMarkup = '';
  // If has a different "compare-at" price, show that
  if (
    variant.compareAtPrice?.amount &&
    variant.price.amount !== variant.compareAtPrice.amount
  ) {
    priceMarkup += `<strike>${formatAsMoney(
      variant.compareAtPrice.amount * quantity,
      getPageLang(),
    )}</strike>`;
  }
  priceMarkup += `<span>${formatAsMoney(
    variant.price.amount * quantity,
    getPageLang(),
  )}</span>`;

  // Update prices on page
  priceEls.forEach((price) => {
    price.dataset.price = (variant.price.amount * quantity).toString();
    price.innerHTML = priceMarkup;
  });
}

/**
 * Update product sku based on variant
 */
function updateVariantSku(product, variant) {
  if (variant) {
    // console.debug(variant);
    let sku = document.querySelector(`.js-product[data-product="${product.handle}"] .js-sp-sku`);
    if (sku) {
      sku.innerHTML = variant.publicSku || variant.sku;
    }

    // Update any sku fields on the page
    const skuFields = document.querySelectorAll<HTMLInputElement>('input.js-update-with-variant[name="sku"]');
    skuFields.forEach((field) => {
      field.value = variant.publicSku || variant.sku;
    });
  }
}

/**
 * Update store availability banner
 * @param locations
 * @param available If the item is available in store
 */
function setStoreAvailability(locations: any[], available: boolean) {
  const storeAvailability = document.querySelector<HTMLElement>('.js-store-availability');
  if (!storeAvailability) {
    return;
  }

  storeAvailability.classList.toggle(
    'single-product__notice--availability',
    available,
  );

  const storeAvailabilityText = storeAvailability.querySelector('p') as HTMLElement;

  if (available) {
    const locationLinks = locations
      .map((location) => {
        const url = stardust.route(`${getPageLang()}.contentful.slug`, { '*': ['contact-us'] });
        return `<a href="${url}">${location.location}</a>`;
      });

    // NOTE: The ICU format doesn't specify list formatting, so we need to do it manually
    const formattedLocations = formatList(locationLinks, i18next.language);
    storeAvailabilityText.innerHTML = t('general:product.availableAt', { locations: formattedLocations });
  } else {
    storeAvailabilityText.innerHTML = t('general:product.notAvailableInStore');
  }
}

/**
 * Update online availability banner
 * @param available If the item is available online
 */
function setOnlineAvailability(available: boolean) {
  const onlineAvailability = document.querySelector<HTMLElement>('.js-online-availability');
  if (!onlineAvailability) {
    return;
  }

  onlineAvailability.classList.toggle(
    'single-product__notice--availability',
    available,
  );

  const onlineAvailabilityText = onlineAvailability.querySelector('p') as HTMLElement;

  if (available) {
    onlineAvailabilityText.innerHTML = t('general:product.immediateShipping');
  } else {
    onlineAvailability.classList.add('single-product__notice--info');
    onlineAvailabilityText.innerHTML = t('general:product.notOnline');
  }
}

/**
 * Check stock levels and update page elements
 */
function updateProductPageStockStatus(product) {
  if (!document.querySelector('main.product')) {
    return;
  }

  // `hidePrice` is from our Shopify model.
  // It's added as a data attribute on the product page
  // because we don't have tags in the JS model from Shopify.
  const hidePrice = document.querySelector('.js-product[data-price-hidden="true"]')
    ? true
    : false;

  const stockUrl = stardust.route('api.shop.stock', undefined, { qs: {
    id: product.selectedVariant.id,
    lang: getPageLang(),
  } });

  fetch(stockUrl, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((response) => {
      const inventory = response.result;

      let locations = inventory.filter((location) => location.available);

      if (locations.length && !hidePrice) {
        enableBuyButtons();
        setStoreAvailability(locations, true);
        setOnlineAvailability(true);
      } else if (locations.length && hidePrice) {
        disableBuyButtons();
        setStoreAvailability(locations, true);
        setOnlineAvailability(false);
      } else {
        disableBuyButtons();
        // show out of stock messaging
        setStoreAvailability(locations, false);
        setOnlineAvailability(false);
      }
    });
}

function disableBuyButtons() {
  document.querySelector('.js-add-to-cart')?.setAttribute('disabled', 'disabled');
  document.querySelector('.js-buy-now')?.setAttribute('disabled', 'disabled');
}

function enableBuyButtons() {
  document.querySelector('.js-add-to-cart')?.removeAttribute('disabled');
  document.querySelector('.js-buy-now')?.removeAttribute('disabled');
}

function buyButtonAnalytics(product, cart, productCard) {
  // TODO: convert to GA4
  if (window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: cart.currencyCode,
      items: [
        {
          item_id: product.variant.sku,
          item_name: product.title,
          item_variant: product.variant.title,
          price: product.variant.price.amount,
          currency: cart.currencyCode,
          quantity: 1,
        },
      ],
      value: product.variant.price.amount,
    });
  }

  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      currency: cart.currencyCode,
      items: [
        {
          item_id: product.variant.sku,
          item_name: product.title,
          item_variant: product.variant.title,
          price: product.variant.price.amount,
          currency: cart.currencyCode,
          quantity: 1,
        },
      ],
      value: product.variant.price.amount,
    });
  }

  // https://www.algolia.com/doc/api-reference/api-methods/added-to-cart-object-ids-after-search/
  // https://www.algolia.com/doc/api-reference/api-methods/added-to-cart-object-ids/

  // TODO: There's probably a better way to grab the index name, but this works for now
  const indexName = document.querySelector<HTMLElement>('.sortBy__button--selected')?.dataset.value;
  const price = parseFloat(product.variant.price.amount);
  const urlParams = new URLSearchParams(window.location.search);
  const queryID = urlParams.get('qid') || productCard?.getAttribute('data-query-id') || null;
  const objectID = urlParams.get('oid') || productCard?.getAttribute('data-object-id') || null;

  if (!queryID || !objectID) {
    console.debug('No queryID/objectID found for Algolia insights tracking');
    return;
  }

  const insightsData = {
    userToken: aa('getUserToken')?.toString(),
    eventName: 'Added to Cart',
    index: indexName ?? DEFAULT_INDEX,
    objectIDs: [objectID],
    queryID,
    objectData: [{
      price,
      quantity: 1,
    }],
    value: price,
    currency: cart.currencyCode,
  };

  aa('addedToCartObjectIDsAfterSearch', insightsData);
}

function updateURLParams(params) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  for (const key in params) {
    urlParams.set(key, params[key]);
  }
  window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);

  // Update any URL fields on the page
  const urlFields = document.querySelectorAll<HTMLInputElement>('input.js-update-with-variant[name="url"]');
  urlFields.forEach((field) => {
    field.value = window.location.href;
  });
}

export default {
  buyButtonClickHandler,
};

export { buyButtonClickHandler };
